import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.split.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import keys from 'lodash/keys';
import transform from 'lodash/transform';
import invert from 'lodash/invert';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import flatten from 'lodash/flatten';
import { stringify } from 'qs';
var PRODUCTS_PER_PAGE = 40;
var IMAGES_PER_PAGE = 48;
var SORT_BY = {
  popular: 'popular',
  publishdate: 'publishdate',
  price: 'price'
};
var ORDER_BY = {
  default: 'default',
  asc: 'asc',
  desc: 'desc'
};
var ENCODED_CATEGORY_FILTERS = {
  color: 'c',
  style: 'st',
  fabric: 'f',
  plus_product: 'pp',
  capacity: 'ca',
  form: 'fo',
  model: 'm',
  ideal_for: 'if',
  more_info: 'mi',
  size_dimensions: 'sd',
  theme: 't',
  price: 'p',
  depth: 'dd',
  height: 'dh',
  width: 'dw',
  category: 'ct',
  offers: 'of',
  mattress_comfort: 'mac',
  sofa_corner: 'soc',
  seat_comfort: 'sec',
  mattress_specificity: 'mas',
  quality_bed: 'qub',
  eco_responsability: 'ecr',
  wick_thickness: 'wit',
  function: 'fun',
  padding: 'pad',
  gramma: 'gra',
  brand: 'bra',
  chair_model: 'chm',
  protective_cover: 'prc',
  furniture_model: 'fum',
  springbox_model: 'spm',
  table_model: 'tam',
  carpet_model: 'cam',
  pattern: 'pat',
  nb_seat: 'nbs',
  nb_door: 'nbdo',
  nb_drawer: 'nbdr',
  support_bed_comfort: 'sub',
  duvet_size: 'dus',
  bed_head_size: 'beh',
  pillow_bolster_size: 'pib',
  bed_size: 'bes',
  technology_mattress: 'tem',
  specific_treatment: 'spt',
  armrest: 'arm',
  sofa_type: 'sot',
  furniture_type: 'fut',
  season: 'sea',
  bathroom_towel_model: 'bat',
  parasol_mast: 'pam',
  lounge_chair_model: 'loc',
  bed_model: 'bem',
  characteristic: 'cha',
  armchair_model: 'armo',
  kitchen_furniture_model: 'kif',
  bathroom_furniture_model: 'baf',
  curtain_tie_type: 'cut',
  modular_type: 'mot',
  pose: 'pos',
  office_model: 'ofm',
  bulb_base_type: 'bbt',
  lamp_model: 'lm',
  mirror_model: 'mm',
  vase_model: 'vm',
  floor_lamp_model: 'flm',
  scent: 'sc',
  type_bulbs: 'tb',
  seller: 'se',
  cup_model: 'cm',
  washable_care: 'wc',
  cooking_tool_model: 'ctm',
  christmas_theme: 'cht'
};
var ENCODED_LOOKBOOK_FILTERS = {
  collection: 'key'
};
var DECODED_CATEGORY_FILTERS = invert(ENCODED_CATEGORY_FILTERS);
var DECODED_LOOKBOOK_FILTERS = invert(ENCODED_LOOKBOOK_FILTERS);

var supportedFilterBy = function supportedFilterBy(query, decoder) {
  var supported = keys(decoder);
  return transform(query, function (currentQuery, value, key) {
    var isSupported = supported.includes(key) && value !== '';
    return Object.assign(currentQuery, isSupported && _defineProperty({}, key, value));
  }, {});
};

var extractFilterByFromQuery = function extractFilterByFromQuery(decoder) {
  return function (query) {
    return transform(supportedFilterBy(query, decoder), function (result, value, key) {
      var currentResult = result;
      currentResult[decoder[key]] = !isEmpty(value) ? value.split(',') : [];
    }, {});
  };
};

var extractQueryFromFilterBy = function extractQueryFromFilterBy(encoder) {
  return function (query) {
    return transform(query, function (result, value, key) {
      var currentResult = result;
      currentResult[encoder[key]] = value.length ? value.join(',') : null;
    }, {});
  };
};

var extractCategoryQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_CATEGORY_FILTERS);
var extractCategoryFilterByFromQuery = extractFilterByFromQuery(DECODED_CATEGORY_FILTERS);

var categoryHasFilters = function categoryHasFilters(query) {
  var filterBy = extractCategoryFilterByFromQuery(query);
  return filterBy && Object.keys(filterBy).length > 0 && filterBy.constructor === Object;
};

var extractLookbookQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_LOOKBOOK_FILTERS);
var extractLookbookFilterByFromQuery = extractFilterByFromQuery(DECODED_LOOKBOOK_FILTERS);

var extractCategorySortByFromQuery = function extractCategorySortByFromQuery(query) {
  return SORT_BY[query.sort] || SORT_BY.popular;
};

var extractCategoryOrderByFromQuery = function extractCategoryOrderByFromQuery(query) {
  return ORDER_BY[query.order] || null;
};

var extractPageFromQuery = function extractPageFromQuery(query) {
  return parseInt(query.page, 10) || 1;
};

var extractCategoryPreviousPageFromQuery = extractPageFromQuery;
var extractCategoryNextPageFromQuery = extractPageFromQuery;

var assembleCategoryQuery = function assembleCategoryQuery(query) {
  var filters = supportedFilterBy(query, DECODED_CATEGORY_FILTERS);

  var aggregated = _objectSpread({
    from: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    size: PRODUCTS_PER_PAGE,
    sort: extractCategorySortByFromQuery(query),
    order: extractCategoryOrderByFromQuery(query)
  }, filters);

  return stringify(omitBy(aggregated, isNil));
};

var buildCategoryProductsQuery = function buildCategoryProductsQuery(query) {
  var filterBy = extractCategoryFilterByFromQuery(query);
  var sortBy = extractCategorySortByFromQuery(query) || SORT_BY.popular;
  var orderBy = extractCategoryOrderByFromQuery(query) || ORDER_BY.default;
  return {
    offset: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    limit: PRODUCTS_PER_PAGE,
    sortBy: sortBy.toUpperCase(),
    orderBy: orderBy.toUpperCase(),
    filterBy: keys(filterBy).map(function (e) {
      return {
        filter: e,
        facets: filterBy[e]
      };
    })
  };
};

var assembleLookbookQuery = function assembleLookbookQuery(query) {
  var filters = supportedFilterBy(query, DECODED_LOOKBOOK_FILTERS);

  var aggregated = _objectSpread({
    from: (extractPageFromQuery(query) - 1) * IMAGES_PER_PAGE,
    size: IMAGES_PER_PAGE
  }, filters);

  return stringify(omitBy(aggregated, isNil));
};

var extractCategoryHash = function extractCategoryHash(url) {
  var regex = /\w*(?=\.html?)|\w*$/;
  return url.match(regex) ? url.match(regex)[0] : null;
};

var extractCategorySlugFromUrl = function extractCategorySlugFromUrl(url) {
  var regex = /(\w([a-z]|[A-Z]|[0-9]){0,}(-)){1,}/g;
  var match = url.match(regex);
  return match ? match[0].substr(0, url.match(regex)[0].length - 1) : null;
};

var extractProductReference = function extractProductReference(url) {
  var regex = /[M]?\d{3,}/g;
  return url.match(regex) ? url.match(regex).slice(-1)[0] : null;
};

var extractFacetLabelFromCategoryFilters = function extractFacetLabelFromCategoryFilters(filters, filter, facet) {
  if (filter === 'price') return facet;
  var extracted = filters.find(function (e) {
    return e.name === filter;
  }).facets.find(function (e) {
    return e.key === facet;
  });
  return extracted ? extracted.label : null;
};

var extractSelectedFilters = function extractSelectedFilters(filterBy, filters) {
  if (!filters) return [];
  var result = [];
  keys(filterBy).forEach(function (filter) {
    var hasFilter = filters ? filters.find(function (e) {
      return e.name === filter;
    }) : false;

    if (hasFilter) {
      result.push(filterBy[filter].map(function (facet) {
        return {
          filter: filter,
          facet: facet,
          label: extractFacetLabelFromCategoryFilters(filters, filter, facet)
        };
      }));
      return;
    }

    var hasDeepFilter = ['depth', 'width', 'height'].includes(filter);

    if (hasDeepFilter) {
      result.push({
        filter: filter,
        facet: filterBy[filter][0],
        label: "".concat(filterBy[filter][0], " cm")
      });
    }
  });
  return flatten(result);
};

var extractMerchantReference = function extractMerchantReference(url) {
  var regex = /\w*(?=\.html?)|\w*$/;
  return url.match(regex) ? url.match(regex)[0] : null;
};

var extractUrlParameter = function extractUrlParameter(paramName, link) {
  var name = paramName.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(name, "=([^&#]*)"));
  var results = regex.exec(link);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export { extractCategoryHash, extractCategorySlugFromUrl, extractProductReference, extractCategoryFilterByFromQuery, extractCategoryQueryFromFilterBy, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractFacetLabelFromCategoryFilters, extractLookbookQueryFromFilterBy, extractLookbookFilterByFromQuery, extractSelectedFilters, extractUrlParameter, assembleCategoryQuery, assembleLookbookQuery, buildCategoryProductsQuery, extractMerchantReference, categoryHasFilters };